import { useCallback, useState } from 'react';
import { validatePasswordReset, type PasswordErrorCode } from '../domain/password';
import { authRepository } from '../infrastructure/auth.repository';
import { apiErrorMessage } from './apiError';

// C-1 (preservado as-is): textos hardcodeados en español — mismos mensajes exactos que
// ResetPasswordPage.jsx legado, mapeados desde los códigos de dominio (domain/password.ts).
const ERROR_MESSAGES: Record<PasswordErrorCode, string> = {
  missingToken: 'Token no válido. Solicita un nuevo enlace de restablecimiento.',
  required: 'Ambos campos son requeridos.',
  tooShort: 'La contraseña debe tener al menos 8 caracteres.',
  mismatch: 'Las contraseñas no coinciden.',
};
const GENERIC_ERROR_MESSAGE = 'Error al restablecer la contraseña.';

/** UC-3: orden exacto de validaciones (T7) + POST /auth/reset-password + estado de éxito. */
export function useResetPassword(token: string | null) {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = useCallback(
    async (newPassword: string, confirmPassword: string): Promise<void> => {
      const code = validatePasswordReset({ token, newPassword, confirmPassword });
      if (code) {
        setError(ERROR_MESSAGES[code]);
        return;
      }
      setLoading(true);
      setError('');
      try {
        await authRepository.resetPassword(token as string, newPassword);
        setSuccess(true);
      } catch (err: unknown) {
        setError(apiErrorMessage(err) || GENERIC_ERROR_MESSAGE);
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { error, success, loading, submit };
}
